import { createClient } from 'pexels';

export const serchImage = async (query) => {
    const list = [];
    const client = createClient('563492ad6f917000010000018f2d048fd9494d7aaa349038438a2003');
    await client.photos.search({ query, per_page: 200 }).then(photos => {
        //console.log(photos.photos)
        //list = [];
        const number = Math.floor(Math.random() * photos.photos.length);
        list.push(photos.photos[number].src.original)
    });
    
    return list
}
